import { render, staticRenderFns } from "./customer-event.vue?vue&type=template&id=0d5ccca1&scoped=true&"
import script from "./customer-event.vue?vue&type=script&lang=js&"
export * from "./customer-event.vue?vue&type=script&lang=js&"
import style0 from "./customer-event.vue?vue&type=style&index=0&id=0d5ccca1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5ccca1",
  null
  
)

export default component.exports